module.exports = __webpack_public_path__ + "static/media/poster.78b6acfd.svg";